import { add, differenceInHours, format } from "date-fns";

import {
  AGENDA_PIXELS_PER_MINUTE,
  TIMEBAR_WIDTH_PX,
} from "@whoosh/design-system/src/apps/PatronApp/screens/multiSlotBooking";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";
import { convertAgendaDateTimeToDate } from "@whoosh/utilities/src/dates";

export const TimeColumn = ({
  firstTime,
  lastTime,
}: {
  firstTime: string | null;
  lastTime: string | null;
}) => {
  /**
   * If we don't have a time range - we just return a spacer box with no times inside
   */
  if (!firstTime || !lastTime) {
    return <Box bg="surface-primary" width={TIMEBAR_WIDTH_PX} />;
  }

  const startDateObj = convertAgendaDateTimeToDate(firstTime);
  const endDateObj = convertAgendaDateTimeToDate(lastTime);
  const totalHours = differenceInHours(endDateObj, startDateObj) + 1;

  return (
    <Box bg="grayscale-0" width={TIMEBAR_WIDTH_PX}>
      {Array.from({ length: totalHours }, (_, index) => {
        const time = add(startDateObj, { hours: index });

        return (
          <Box
            key={index}
            height={AGENDA_PIXELS_PER_MINUTE * 60}
            width="100%"
            borderTopWidth={1}
            borderColor="surface-dividers"
          >
            <Box position="absolute" top={15} right={34}>
              <Text
                fontSize={16}
                fontWeight="bold"
                textAlign="left"
                lineHeight={16}
              >
                {format(time, "h")}
              </Text>
            </Box>
            <Box position="absolute" top={15} right={4}>
              <Text
                textAlign="left"
                style={{ paddingLeft: 30 }}
                variant="mainMicro"
                lineHeight={10}
              >
                00
              </Text>
            </Box>
            <Box position="absolute" top={30} right={34}>
              <Text textAlign="left" pl={3} fontSize={10} color="grayscale-900">
                {format(time, "aaa")}
              </Text>
            </Box>
            <Box
              borderWidth={0.5}
              position="absolute"
              top={AGENDA_PIXELS_PER_MINUTE * 30 - 1}
              right={0}
              width={17}
              borderColor="surface-dividers"
            />
            <Box position="absolute" top={84} right={4}>
              <Text
                textAlign="left"
                style={{ paddingLeft: 30 }}
                variant="mainMicro"
                lineHeight={10}
              >
                30
              </Text>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
